export default __webpack_public_path__ + "static/media/arrow-up-right.3d9b35f3.svg";